import { ICommonApi } from '../../api'
import { concat, Observable, of } from 'rxjs'
import { combineEpics, ofType, StateObservable } from 'redux-observable'
import { IStoreState } from '../../reducers/types'
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { dangerToast } from '../../common/toast'
import {
  arkiveringStatusActions,
  arkiveringStatusActionsTypes,
} from './actions'
import { AnyAction } from 'redux'
import { ENDPOINT } from '../../constants'

const ROOT_URL = `${ENDPOINT.ARKIV}/arkiv/bilder/saksnummer`

export const fetchArkiveringStatus =
  (commonApi: ICommonApi) =>
  (action$: Observable<AnyAction>, state$: StateObservable<IStoreState>) =>
    action$.pipe(
      ofType(arkiveringStatusActionsTypes.FETCH),
      withLatestFrom(state$),
      mergeMap(([{ aar, hoveddokumentId, sekvensnummer }, state]) => {
        const URL = `${ROOT_URL}/${aar}/${sekvensnummer}/hoveddokumentId/${hoveddokumentId}/arkivert`
        return of(state).pipe(
          commonApi.get(URL, state),
          map((resp) => resp._embedded?.archiveJobs || []),
          map((resp) => arkiveringStatusActions.fetchSuccess(resp)),
          catchError((err) => {
            return concat(
              of(arkiveringStatusActions.fetchFailed(err.message)),
              of(dangerToast('Kunne ikke hente arkiveringsstatus'))
            )
          })
        )
      })
    )

const fetchArkiveringStatusEpic = (commonApi: ICommonApi) =>
  combineEpics(fetchArkiveringStatus(commonApi))

export default fetchArkiveringStatusEpic
